import ProductDetailPage from '$lib/storyblok/pages/productDetailPage.svelte';
import PdpHero from '$lib/storyblok/blocks/pdpHero.svelte';
import PdpHeadline from '$lib/storyblok/blocks/pdpHeadline.svelte';
import LandingPageHero from '$lib/storyblok/blocks/landingPageHero.svelte';
import LandingPageModuleHeadline from '$lib/storyblok/blocks/landingPageModuleHeadline.svelte';
import defaultComponents from '$lib/storyblok/defaultComponents';
import PdpHeroV2 from '$lib/storyblok/blocks/pdpHeroV2.svelte';
import PdpHeroCarousel from '$lib/storyblok/blocks/PdpHeroCarousel.svelte';
import PdpHeroContent from '$lib/storyblok/blocks/pdpHeroContent.svelte';
import SbGrid from '$lib/storyblok/blocks/sbGrid.svelte';
import IconWithText from '$lib/storyblok/blocks/iconWithText.svelte';
import YotpoReviewsWidget from '$lib/storyblok/blocks/yotpoReviewsWidget.svelte';
import PdpHeroContentV2 from '$lib/storyblok/blocks/pdpHeroContentV2.svelte';
import PdpPrice from '$lib/storyblok/blocks/pdpPrice.svelte';
import PdpHeroCarouselV2 from '$lib/storyblok/blocks/PdpHeroCarouselV2.svelte';
import { registerComponents } from '$lib/storyblok/sdk';
import PdpSubnav from '$lib/storyblok/blocks/pdp/pdpSubnav.svelte';
import PdpSubnavItem from '$lib/storyblok/blocks/pdp/pdpSubnavItem.svelte';
import WhatGoesInGrid from '$lib/storyblok/blocks/pdp/whatGoesInGrid.svelte';
registerComponents({
	...defaultComponents,
	grid: SbGrid,
	icon_with_text: IconWithText,
	product_detail_page: ProductDetailPage,
	product_detail_page_hero: PdpHero,
	product_detail_page_headline: PdpHeadline,
	landing_page_hero: LandingPageHero,
	landing_page_module_headline: LandingPageModuleHeadline,
	pdp_hero_v2: PdpHeroV2,
	pdp_hero_carousel: PdpHeroCarousel,
	pdp_hero_carousel_v2: PdpHeroCarouselV2,
	pdp_hero_content: PdpHeroContent,
	pdp_hero_content_v2: PdpHeroContentV2,
	yotpo_reviews_widget: YotpoReviewsWidget,
	pdp_price: PdpPrice,
	pdp_subnav: PdpSubnav,
	pdp_subnav_item: PdpSubnavItem,
	what_goes_in_grid: WhatGoesInGrid
});
